/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import {
  CompanyRegistrationResourceService,
  SubscriptionTypeResourceService,
} from '@well/resource-services';
import { SubscriptionTypeVoModel } from '@well/domain';
import { Observable } from 'rxjs';
import { JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})
export class SignupSubscriptionPlanService {

  constructor(private subscriptionTypeResourceService: SubscriptionTypeResourceService,
              private companyRegistrationResourceService: CompanyRegistrationResourceService) { }

  getSubscriptionTypesByLegalEntity(legalEntityUuid: string): Observable<JsonApiResource<SubscriptionTypeVoModel[], JsonApiListResourceMetadataBase>>{
    return this.subscriptionTypeResourceService.getSubscriptionTypesForLegalEntity(legalEntityUuid);
  }

  createNewAccountStatusIfNotExistsForCurrentOwner() {
    return this.companyRegistrationResourceService.createNewAccountStatusIfNotExistsForCurrentOwner();
  }
}
